import { fonts, colors } from '../../../styles'

export default {
	fontFamily: fonts.paragraph,
	color: colors.white,
	fontSize: 16,
	marginTop: 16,
	marginBottom: 16,
	lineHeight: 1.5,
	textShadow: '1px 1px #000',
	letterSpacing: '0.2px'
}



// WEBPACK FOOTER //
// ./src/components/format/Paragraph/styles.js